export function generateHtmlFromRideData(ride) {
  const escapeHtml = (unsafe = '') => {
      return String(unsafe)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
  };

  // Detect language from ride data
  const rideLanguage = ride?.ride?.language;
  const isEnglish = rideLanguage === 'english' || rideLanguage === 'en';
  
  // Translation object
  const translations = {
    he: {
      day: 'יום',
      offlineIndicator: 'מצב תצוגה לא מקוון - ייתכן שהמידע אינו מעודכן',
      activities: 'פעילויות:',
      accommodation: 'מקום לינה:',
      location: 'מיקום:',
      copy: 'העתק',
      locationCopied: 'המיקום הועתק:',
      failedToCopy: 'לא הצלחנו להעתיק. נא להעתיק ידנית:'
    },
    en: {
      day: 'Day',
      offlineIndicator: 'Offline view mode - information may not be up to date',
      activities: 'Activities:',
      accommodation: 'Accommodation:',
      location: 'Location:',
      copy: 'Copy',
      locationCopied: 'Location copied:',
      failedToCopy: 'Failed to copy. Please copy manually:'
    }
  };

  const t = (key) => translations[isEnglish ? 'en' : 'he'][key] || key;

  const rideTitle = escapeHtml(ride?.ride?.title || '');
  const rideText = ride?.ride?.text || '';

  let tabsHtml = '';
  let daysHtml = '';

  (ride?.attractionsByDay || []).forEach((day, index) => {
    tabsHtml += `<button class="tab-button" onclick="showDay(${index})">${t('day')} ${index + 1}</button>`;

    // Add day extra information if exists
    const dayExtraInfo = (ride?.ride?.rideExtraInformationByDay || []).find(info => info.date === day.dateTime);
    let dayExtraInfoHtml = '';
    if (dayExtraInfo) {
      dayExtraInfoHtml = `
        <div class="day-extra-info">
          <div class="day-extra-info-text">${dayExtraInfo.text}</div>
        </div>
      `;
    }

    let attractionsHtml = '';
    (day.daily_attractions || []).forEach(attraction => {
      const hasValidCoords = (
        typeof attraction.latitude === 'number' &&
        typeof attraction.longtitude === 'number' &&
        !isNaN(attraction.latitude) &&
        !isNaN(attraction.longtitude)
      );
      attractionsHtml += `
        <div class="activity-item">
          <p class="activity-title">${escapeHtml(attraction.title)}</p>
          ${attraction.text ? `<p class="activity-text">${attraction.text}</p>` : ''}
          ${hasValidCoords ? `
            <div class="map-button-offline">
              ${t('location')} ${attraction.latitude}, ${attraction.longtitude}
              <button onclick="copyCoordinates('${attraction.latitude},${attraction.longtitude}')">${t('copy')}</button>
            </div>` : ''}
        </div>`;
    });

    const accommodation = day.accommodation;
    let accommodationHtml = '';
    if (accommodation && (accommodation.name )) {
      const hasValidCoords = (
        typeof accommodation.latitude === 'number' &&
        typeof accommodation.longtitude === 'number' &&
        !isNaN(accommodation.latitude) &&
        !isNaN(accommodation.longtitude)
      );
      accommodationHtml = `
        <div class="accommodation-container">
          <h3 class="accommodation-heading">${t('accommodation')}</h3>
          ${accommodation.name ? `<p class="accommodation-name">${escapeHtml(accommodation.name)}</p>` : ''}
          ${accommodation.cuntry_and_city ? `<p class="accommodation-location">${escapeHtml(accommodation.cuntry_and_city)}</p>` : ''}
          ${accommodation.text ? `<p class="accommodation-text">${accommodation.text}</p>` : ''}
          ${hasValidCoords ? `
            <div class="map-button-offline">
              ${t('location')} ${accommodation.latitude}, ${accommodation.longtitude}
              <button onclick="copyCoordinates('${accommodation.latitude},${accommodation.longtitude}')">${t('copy')}</button>
            </div>` : ''}
        </div>`;
    }

    daysHtml += `
      <div id="day-${index}" class="ride-day-container" style="display: ${index === 0 ? 'block' : 'none'}">
        <h2 class="ride-day-title">${t('day')} ${index + 1} - ${day.dateTime?.split('00:00')[0] || ''}</h2>
        ${dayExtraInfoHtml}
        <h3 class="activity-heading">${t('activities')}</h3>
        <div class="activity-list">
          ${attractionsHtml}
        </div>
        ${accommodationHtml}
      </div>`;
  });

  const extraHtml = (ride?.ride?.rideExtraInformation || []).map(info => `
    <div class="extra-info-section">
      <h3 class="extra-info-title">${escapeHtml(info.title)}:</h3>
      <p class="extra-info-text">${info.text}</p>
    </div>
  `).join('');

  // Dynamic styles based on language
  const direction = isEnglish ? 'ltr' : 'rtl';
  const textAlign = isEnglish ? 'left' : 'right';
  const marginSide = isEnglish ? 'margin-left' : 'margin-right';

  const styles = `
    <style>
      .offline-ride-container { max-width: 800px; margin: 0 auto; direction: ${direction}; background-color: #f9fafb; padding: 16px; }
      .rtl-text { text-align: ${textAlign}; }
      .ride-title { font-size: 26px; font-weight: bold; text-align: center; margin-bottom: 16px; color: #111; }
      .ride-summary { text-align: center; margin-bottom: 24px; font-size: 16px; color: #444; white-space: pre-wrap; }
      .tab-container { margin-bottom: 24px; }
      .tab-buttons { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; justify-content: center; }
      .tab-button { background-color: #e2e8f0; border: none; padding: 8px 16px; font-size: 14px; border-radius: 4px; cursor: pointer; }
      .tab-button.active { background-color: #3b82f6; color: white; }
      .ride-day-container { padding: 16px; border: 1px solid #ccc; border-radius: 8px; background-color: #fff; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); }
      .ride-day-title { font-size: 20px; font-weight: 600; margin-bottom: 16px; padding-bottom: 8px; border-bottom: 1px solid #eee; color: #222; }
      .activity-heading { font-size: 18px; font-weight: bold; margin-bottom: 12px; color: #333; }
      .activity-list { padding: 0; }
      .activity-item { background-color: #f8f9fa; border: 1px solid #ddd; border-radius: 6px; padding: 12px; margin-bottom: 12px; }
      .activity-title { font-size: 16px; font-weight: 600; margin-bottom: 8px; color: #111; }
      .activity-text { font-size: 14px; color: #555; margin-bottom: 8px; white-space: pre-wrap; }
      .map-button { font-size: 14px; color: #1a73e8; text-decoration: underline; background: none; border: none; cursor: pointer; }
      .accommodation-container { margin-top: 24px; background-color: #f1f5f9; border: 1px solid #ccc; border-radius: 6px; padding: 12px; }
      .accommodation-heading { font-size: 18px; font-weight: bold; margin-bottom: 8px; color: #333; }
      .accommodation-name { font-size: 16px; font-weight: 600; margin-bottom: 4px; color: #111; }
      .accommodation-location { margin-bottom: 4px; font-size: 14px; color: #555; }
      .accommodation-text { font-size: 14px; color: #555; margin-bottom: 8px; white-space: pre-wrap; }
      .extra-info-section { margin-top: 32px; background-color: #fff; padding: 16px; border: 1px solid #ddd; border-radius: 6px; }
      .extra-info-title { font-size: 18px; font-weight: bold; margin-bottom: 8px; color: #222; }
      .extra-info-text { font-size: 14px; color: #444; line-height: 1.6; white-space: pre-wrap; }
      .offline-indicator { background-color: #fde047; color: #92400e; padding: 12px; text-align: center; font-weight: bold; border-radius: 6px; margin-bottom: 20px; font-size: 14px; }
      .map-button-offline { font-size: 14px; color: #333; margin-top: 8px; }
      .map-button-offline button { background-color: #3b82f6; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; ${marginSide}: 8px;}
      .day-extra-info { background-color: #f8f9fa; border: 1px solid #ddd; border-radius: 6px; padding: 12px; margin-bottom: 16px; }
      .day-extra-info-text { font-size: 14px; color: #444; line-height: 1.6; white-space: pre-wrap; }
      @media print {
        body { display: none !important; }
      }
    </style>
  `;

  return `
  <!DOCTYPE html>
  <html lang="${isEnglish ? 'en' : 'he'}">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${rideTitle}</title>
    ${styles}
  </head>
  <body dir="${direction}">
    <div class="offline-ride-container rtl-text">
      <div class="offline-indicator">${t('offlineIndicator')}</div>
      <h1 class="ride-title">${rideTitle}</h1>
      <p class="ride-summary">${rideText}</p>
      <div class="tab-container">
        <div class="tab-buttons">${tabsHtml}</div>
        ${daysHtml}
      </div>
      ${extraHtml}
    </div>
    <script>
      function showDay(index) {
        document.querySelectorAll('.ride-day-container').forEach((el, i) => {
          el.style.display = (i === index) ? 'block' : 'none';
        });
        document.querySelectorAll('.tab-button').forEach((el, i) => {
          el.classList.toggle('active', i === index);
        });
      }

      window.addEventListener('online', function() {
        try {
          var rideId = localStorage.getItem('lastRideId');
          if (rideId) {
            var savedPosition = localStorage.getItem('scrollPositionBeforeOffline');
            if (savedPosition !== null) {
              localStorage.setItem('scrollPositionToRestore', savedPosition);
              localStorage.removeItem('scrollPositionBeforeOffline');
            }
            window.location.href = '/single_ride_with_map/' + rideId;
          }
        } catch (e) {
          console.error('Failed to redirect after reconnect:', e);
        }
      });
      
      function copyCoordinates(coords) {
        const isEnglish = ${isEnglish};
        const translations = {
          he: {
            locationCopied: "המיקום הועתק:\\n",
            failedToCopy: "לא הצלחנו להעתיק. נא להעתיק ידנית:\\n"
          },
          en: {
            locationCopied: "Location copied:\\n",
            failedToCopy: "Failed to copy. Please copy manually:\\n"
          }
        };
        
        const t = translations[isEnglish ? 'en' : 'he'];
        
        try {
          navigator.clipboard.writeText(coords);
          alert(t.locationCopied + coords);
        } catch (e) {
          alert(t.failedToCopy + coords);
        }
      }
    </script>
  </body>
  </html>`;
}